export const TYPES = {
  WorkspacesDao: Symbol.for('WorkspacesDao'),
  WorkspacesApiService: Symbol.for('WorkspacesApiService'),
  WorkspacesStateRepository: Symbol.for('WorkspacesStateRepository'),
  WorkspacesUseCases: Symbol.for('WorkspacesUseCases'),
};
